module.exports = __webpack_public_path__ + "img/guwu2.b915e562.png";